import { isEqual } from 'lodash';
import { useCallback, useEffect } from 'react';

import { usePrevious, useStorage } from 'hooks';
import { VisibleColumns } from 'types';

import { useQueryData } from './use-query-data.hook';

const STORAGE_KEY = 'spay-order-monitoring-columns';

export function useQueryColumns(initialData?: VisibleColumns) {
  const {
    value: storageValue,
    set: setStorageValue,
    remove: removeStorageValue,
  } = useStorage<VisibleColumns>(STORAGE_KEY, initialData || {});
  const prevStorageValue = usePrevious(storageValue);

  const {
    data: visibleColumns,
    initialized,
    setData,
    reset,
  } = useQueryData<VisibleColumns>('columns', initialData);

  const setVisibleColumns = useCallback(
    (data: VisibleColumns) => {
      setStorageValue(data);
    },
    [setStorageValue],
  );

  const resetVisibleColumns = useCallback(() => {
    removeStorageValue();
    reset();
  }, [removeStorageValue, reset]);

  useEffect(() => {
    if (storageValue && !isEqual(storageValue, prevStorageValue)) {
      setData(storageValue);
    }
  }, [setData, storageValue, prevStorageValue]);

  return {
    visibleColumns,
    initialized,
    setVisibleColumns,
    resetVisibleColumns,
  };
}
